import $ from "jquery";
import { RecipeData, RelatedRecipesView } from "./related_recipes_view";
import { RelatedRecipe } from "../model/related_recipe";

class RelatedCombinationRecipesView extends RelatedRecipesView {
  protected keyword: string;

  constructor(rootElement: JQuery, keyword: string) {
    super(rootElement);
    this.keyword = keyword;
  }

  initialize(): void {
    const headElement = `
      <div class="related_recipes_box_vert f_right">
        <div class="recipes_box">
          <div class="indicator gr" />
        </div>
      </div>
    `;

    this.rootElement.append(headElement);
    this.recipesBoxElement = this.rootElement.find(".recipes_box");
  }

  renderRelatedRecipes(groupedRecipes: RecipeData[]): void {
    this.removeIndicator();

    if (this.numRecipes(groupedRecipes) > 0) {
      Object.entries(groupedRecipes).forEach(([pairingItem, recipes]) => {
        if (recipes.length > 0) {
          this.recipesBoxElement!.append(
            this.combinationHeaderElement(pairingItem),
          );

          recipes.forEach((recipeData, index) => {
            const recipe = new RelatedRecipe(
              recipeData,
              this.blankLogoSrc(),
              index + 1,
            );
            this.recipesBoxElement!.append(recipe.toHtml());
          });
        }
      });
    } else {
      this.showNotFoundMessage();
    }
  }

  renderKeywordNotFoundMessage(): void {
    this.removeIndicator();
    this.showNotFoundMessage();
  }

  protected showNotFoundMessage(): void {
    this.removeIndicator();
    this.renderMessage("関連レシピは見付かりませんでした");
  }

  private combinationHeaderElement(pairingItem: string): string {
    // HTMLエスケープ処理
    const escapedKeyword = $("<div>").text(this.keyword).html();
    const escapedPairingItem = $("<div>").text(pairingItem).html();

    return `<h3>${escapedKeyword}×${escapedPairingItem}</h3>`;
  }

  private numRecipes(groupedRecipes: RecipeData[]): number {
    return Object.values(groupedRecipes)
      .map((recipes) => recipes.length)
      .reduce((total, count) => total + count, 0);
  }

  // Getter for keyword (useful for external access)
  getKeyword(): string {
    return this.keyword;
  }

  // Override parent method to handle grouped recipes specifically
  renderErrorMessage(message: string): void {
    this.removeIndicator();
    // HTMLエスケープ処理
    const escapedMessage = $("<div>").text(message).html();
    this.recipesBoxElement!.append(`<p class="error">${escapedMessage}</p>`);
  }

  // Utility method to check if any recipes exist in grouped data
  hasAnyRecipes(groupedRecipes: RecipeData[]): boolean {
    return this.numRecipes(groupedRecipes) > 0;
  }

  // Get all recipe data as flat array (useful for further processing)
  getFlatRecipeList(groupedRecipes: RecipeData[]): RecipeData[] {
    return Object.values(groupedRecipes).flat();
  }

  // Get pairing items that have recipes
  getActivePairingItems(groupedRecipes: RecipeData[]): string[] {
    return Object.entries(groupedRecipes)
      .filter(([, recipes]) => recipes.length > 0)
      .map(([pairingItem]) => pairingItem);
  }
}

// Global export
window.tablemill = window.tablemill || {};
window.tablemill.RelatedCombinationRecipesView = RelatedCombinationRecipesView;

export { RelatedCombinationRecipesView };
